import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function Error(props) {
  return (
    <Svg
      width={props.width ? props.width : "19"}
      height={props.height ? props.height : "18"}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M18.6052 13.7734L11.8934 1.36973C10.8151 -0.455365 8.18636 -0.45779 7.10655 1.36973L0.395099 13.7734C-0.707272 15.6384 0.627367 18 2.78799 18H16.2118C18.3706 18 19.7076 15.6403 18.6052 13.7734ZM9.5 15.7616C8.88628 15.7616 8.38672 15.2593 8.38672 14.6424C8.38672 14.0254 8.88628 13.5232 9.5 13.5232C10.1137 13.5232 10.6133 14.0254 10.6133 14.6424C10.6133 15.2593 10.1137 15.7616 9.5 15.7616ZM10.6133 11.2847C10.6133 11.9017 10.1137 12.4039 9.5 12.4039C8.88628 12.4039 8.38672 11.9017 8.38672 11.2847V5.68866C8.38672 5.07168 8.88628 4.56945 9.5 4.56945C10.1137 4.56945 10.6133 5.07168 10.6133 5.68866V11.2847Z"
        fill="#FF2E00"
      />
    </Svg>
  );
}

export default Error;
